import { Application, ApplicationBuilder } from "@fastoche/core";
import { VuePlugin } from "./VuePlugin";
import { GlobalApplicationContext } from "./GlobalApplicationContext";
/**
 * A builder to configure a Vue.js application, using the Fastoche.js module system.
 * <br>The constructor of the class is not public: you must use the static method `create`, present on the constructor.
 */
export class VueApplicationBuilder extends ApplicationBuilder {
    /**
     * Create a new instance of the builder
     * @param logger A logger instance
     * @returns An instance of the builder
     */
    static create(logger) {
        return new VueApplicationBuilder(logger);
    }
    /**
     * Set the options for the root component of the application
     */
    root(options) {
        this.rootComponentOptions = options;
        return this;
    }
    /**
     * @internal
     */
    appendDefaultPlugins() {
        if (!this.rootComponentOptions) {
            throw new Error("You must set the options for the root component of the application.");
        }
        this.plugin(VuePlugin, { options: this.rootComponentOptions });
    }
    /**
     * Start the application
     */
    async start() {
        this.appendDefaultPlugins();
        this.applyLazyActions();
        this.config.rootContainer.options.skipBaseClassChecks = true;
        const app = new Application(this.logger, this.config);
        GlobalApplicationContext.default.fastoche = app;
        return app.start();
    }
}
//# sourceMappingURL=VueApplicationBuilder.js.map